document.addEventListener('click', (e) => {
  if (e.target && (e.target.classList.contains('scrollto') || e.target.closest('.scrollto'))) {
    const item = e.target.classList.contains('scrollto') ? e.target : e.target.closest('.scrollto');
    const target = item.hash;

    if (document.querySelectorAll(target).length) {
      const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;
      const elementOffset = document.querySelector(target).getBoundingClientRect().top;
      const scrollPosition = window.pageYOffset;
      const documentTop = scrollElement.clientTop;
      const headerHeight = document.querySelector('.header__fixed').offsetHeight;
      const scrollOffset = Math.round(elementOffset + scrollPosition - documentTop);

      if (item.getAttribute('href').charAt(0) === '#') {
        e.preventDefault();
        window.scroll({
          top: scrollOffset - headerHeight,
          behavior: 'smooth'
        });
        window.onscroll = e => {
          let currentScrollOffset = window.pageYOffset || document.documentElement.scrollTop;
          if (currentScrollOffset === scrollOffset) {
            window.onscroll = null;
          }
        };
      }
    }
  }
});
